import { createRequest } from 'mk-biz-pc'
import { Config } from './config'

const adminApi = createRequest('admin')

/**
 * 获取应用列表
 * @returns
 */
export const getAppList = () => adminApi(Config.getAppList)

/**
 * 查询应用列表
 * @param params
 * @returns
 */
export const queryAppList = (params: any) => adminApi(Config.queryAppList, { params })
